<template>
    <div class = "containerAlign">
        <div class="register__form">
            <p class="register--title mb-0">PAN number</p>
            <p class="register--subtitle">Please enter your PAN number.</p>
            <ValidationObserver slim v-slot="{ invalid }">
                <ValidationProvider name="Pan" rules="alpha_num|length:10|required" v-slot="{ errors, classes }">
                    <div class="labelWidth input-group mb-15" :class="classes">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <img src = "/img/Pan_onBoarding.svg">
                            </span>
                        </div>
                        <input placeholder = "DXPMC2412G" type="text" class="form-control pan-form" maxLength="10" v-model="pan">
                    </div>
                    <div class = "errorMessage">
                            <small class="form-group--error-message">{{ errors[0] }}</small>
                    </div>
                </ValidationProvider>
                <ValidationProvider name="Name" rules="required|regex:^([a-zA-Z\.]+\s)*[a-zA-Z\.]+$" v-slot="{ errors, classes }">
                    <div class = "labelWidth">
                        <label class="labelPan register--label mt-30 mb-5" for="mobile">Name as per Aadhaar</label>
                        <small class="editButton mt-30 rightAlign" v-if="!editName"><a @click="editNameField">Edit</a></small>
                    </div>
                    <div class="labelWidth mb-15" :class="classes">
                        <input type="search" class="labelWidth form-input" v-model="name" :disabled="isNameFieldDisabled">
                        <small class="form-group--error-message">{{ errors[0] }}</small>
                    </div>
                </ValidationProvider>
                <ValidationProvider name="Date" rules="required" v-slot="{ errors}">
                    <div class = "labelWidth">
                        <label class="labelPan register--label  mt-15 mb-5" for="mobile">DOB as per Aadhaar</label>
                        <small class="editButton mt-15 rightAlign" v-if="!editDate"><a @click="editDateField">Edit</a></small>
                    </div>
                    <div class = "labelWidth">
                        <v-menu
                            ref="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <input
                                    class="form-input"
                                    readonly="readonly"
                                    :disabled="!editDate"
                                    v-model="date"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                            </template>
                            <v-date-picker
                                v-model="date"
                                active-picker.sync="YEAR"
                                :disabled="!editDate"
                                :max="currentDate"
                                locale="en-In"
                                min="1899-01-01"
                                @change="saveDate"
                            ></v-date-picker>
                        </v-menu>
                        <small class="form-group--error-message">{{ errors[0] }}</small>
                        <div class="dob--message">
                            <small class="labelWidth notifyText form-group--error-message mt-10" v-if="editDate">Please enter your Date of Birth as per your PAN</small>
                            <small class="labelWidth notifyText form-text text-muted mt-10" v-else>Please ensure that Date of Birth matches your PAN</small>
                        </div>
                    </div>
                </ValidationProvider>
                <div style="display: flex; justify-content: center; align-items: center" class="labelWidth register__form--referral-bottom">
                    <button class="panVerification btn_new btn-secondary-new w-80 mt-15 mb-15" @click="submitPan" :disabled="invalid">Submit </button>
                </div>
            </ValidationObserver>
            <v-snackbar
                v-model="isFailure"
                app
                timeout="-1"
            >
                    {{failureText}}
                <template v-slot:action="{ attrs }">
                    <v-btn
                        color="red"
                        text
                        v-bind="attrs"
                        @click="isFailure = false"
                    >
                    Close
                    </v-btn>
                </template>
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import onboardingService from '@/services/lenderOnboardingService'
const { isDate } = require('@/util/util.js')

export default {
    name: 'PanVerification',
    data () {
        return {
            pan: null,
            isFailure: false,
            failureText: 'Something went wrong. Please try again!',
            name: '',
            date: null,
            menu: false,
            editName: false,
            editDate: false,
            activePicker: false,
            currentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        }
    },
    mounted () {
        this.name = this.$store.state.onBoarding.Name
        if (isDate(this.$store.state.onBoarding.dob)) {
            this.date = this.$store.state.onBoarding.dob
        } else {
            this.editDate = true
            this.date = null
        }
    },
    computed: {
        isNameFieldDisabled () {
            if (!this.editName) {
                return true
            }
            return false
        }
    },
    methods: {
        async submitPan () {
            // call pan api
            this.$store.commit('isLoading')
            this.doCkycRequest()
            this.pan = this.pan.toUpperCase()
            const payload = {
                consent: 'Y',
                pan: this.pan,
                name: this.name,
                dob: this.date
            }
            await onboardingService.verifyPan(payload).then((res) => {
                if (res.status === 200) {
                    this.$store.state.onBoarding.Name = this.name
                    this.success()
                } else if (res.status === 400) {
                    this.isFailure = true
                    this.failureText = 'Please ensure your Pan Number and Other Details are correct!'
                } else {
                    this.pan = null
                    this.isFailure = true
                }
            })
            this.$store.commit('isNotLoading')
        },
        editNameField () {
            this.editName = true
        },
        editDateField () {
            this.editDate = true
        },
        saveDate (date) {
            this.$refs.menu.save(date)
        },
        success () {
            this.$store.dispatch('onBoarding/setField', { field: 'Pan', value: this.pan })
            this.$emit('success')
        },
        doCkycRequest () {
            const userData = localStorage.vuex
            const parseData = JSON.parse(userData)
            const userId = parseData.dashboard.userId
            const payload = {
                userId: userId
            }
            try {
                const response = onboardingService.cKycPostData(payload)
                console.log(JSON.stringify(response))
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/sass/components/registration-flow.scss";
    .panVerification {
    }
    .pan-form {
        text-transform: uppercase;
    }

    .dob--message {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .isEditing input{
        border-color: red !important;
    }
    ::placeholder {
    color: #e0e0e0
    }
    .errorMessage {
        display: flex;
        flex-direction: column;
    }
    .labelPan {
        color: #666E75 !important;
    }
    .notifyText {
        color: #9E9E9E !important;
        text-align: right !important;
        width: 385px !important;
    }
    .editButton {
        text-decoration: underline;
        float: right;
        align-items: center !important;
        font-size: 12px;
        color: #007aff !important;
    }
    .labelWidth {
        width: 345px;
    }

    @media (max-width: 990px) {
    .labelWidth {
        width: 336px
        }
    }
    .containerAlign {
        display: flex;
        justify-content: center;
        align-items: center
    }

</style>
